import * as types from "../constants";

const initialState = {
    data: "",
    error: null,
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {

        case types.GET_ORGANIZATIONS_REQUEST:
            return Object.assign({}, state, {
                error: null,
                loading: true
            });

        case types.GET_ORGANIZATIONS_SUCCESS:
            return Object.assign({}, state, {
                data: action.data,
                loading: false,
                error: null
            });

        case types.GET_ORGANIZATIONS_FAILURE:
            return Object.assign({}, state, {
                error: action.error,
                loading: false
            });
        default:
            return state;
    }
}
